import { tns } from 'tiny-slider/src/tiny-slider'

window.sliders = [];

// Calendar Events
let calendarEvents = document.querySelectorAll('.block.calendar-events')
for (let index = 0; index < calendarEvents.length; index++) {
	const element = calendarEvents[index];
	window.sliders['calendarEvents' + element.getAttribute("data-calendar-events")] = tns({
		container: element.querySelector(".slider"),
		items: 1,
		gutter: 40,
		edgePadding: 60,
		controls: false,
		navPosition: 'bottom',
		autoplay: false,
		autoplayButtonOutput: false,
		loop: false,
		responsive: {
			600: {
                edgePadding: 120,
            },
            720: {
                items: 2,
            },
			1240: {
                items: 3,
			},
            1760: {
                items: 4
            },
            2280: {
                items: 5
            },
            2800: {
                items: 6
            }
		},
        mouseDrag: true
	});
}

// Galleries
// let galleries = document.querySelectorAll('.block.gallery.carousel')
// for (let index = 0; index < galleries.length; index++) {
// 	const element = galleries[index];
// 	window.sliders['gallery' + element.getAttribute("data-gallery")] = tns({
// 		container: element.querySelector(".slider"),
// 		items: 1,
// 		gutter: 14,
// 		edgePadding: 60,
// 		controls: false,
// 		navContainer: element.querySelector(".controls"),
// 		autoplay: true,
// 		autoplayButtonOutput: false,
// 		loop: false,
// 		responsive: {
// 			640: {
// 				gutter: 28,
// 				edgePadding: 120
// 			},
// 			960: {
// 				gutter: 42,
// 				edgePadding: 180
// 			}
// 		}
// 	});
// }